import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useFocusTrap } from '../../../hooks/useFocusTrap';

// Großansicht der Skizze. Esc, Klick daneben oder X schließt; der Fokus
// kehrt über useFocusTrap zum auslösenden Knopf zurück.
export default function SketchLightbox({ src, alt, onClose }) {
  const ref = useRef(null);
  useFocusTrap(ref, true, onClose);
  return createPortal(
    <div
      ref={ref}
      role="dialog"
      aria-modal="true"
      aria-label="Skizze groß"
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-8"
      onClick={onClose}
    >
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', background: '#fff', borderRadius: 8 }}
      />
      <button
        type="button"
        aria-label="Schließen"
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-lg bg-surface text-ink-2 hover:text-ink"
      >
        <X size={18} aria-hidden="true" />
      </button>
    </div>,
    document.body
  );
}
